import { EditForm } from "features/Campaign/components/CampaignForm";

const CampaignEditForm = () => {
  return <EditForm />;
};

export default CampaignEditForm;
